import React from "react";
import { Row, Col, Container } from "reactstrap";
import "../styles/Description.css";

const Description = () => {
  return (
    <React.Fragment>
      <div className="description-bg">
        <Container>
          <h2 className="what-exactly-is-des text-center mb-5">
            Why Choose Orion Stars for Sweepstakes Games Online?
          </h2>
          <p style={{ marginBottom: "3rem" }}>
            Get the ultimate online gaming experience with Orion Stars. We offer
            an incredible selection of thrilling free offline casino games
            featuring Orion Stars 777 Slots, Fish Games slots , and many more.
            Join non-stop action on any device and fully immerse yourself in
            seamless gameplay from start to finish.
          </p>
          <Row className="variety-wrapper variety-wrapper-1">
            <Col xs={12} sm={12} md={6} lg={3} className="mb-4">
              <div className="feature-card">
                <i className="bi bi-shield-lock feature-icon"></i>
                <h3 className="feature-title">
                  Seamless Gameplay Anytime, Anywhere
                </h3>
                <p className="feature-description">
                  Download Orion Stars and join a gaming paradise for non-stop
                  action. Enjoy a seamless experience on any device. Whether you
                  are using an Android, iOS, or Windows device, dive into
                  exhilarating gameplay with no lag, delays, or interruption.
                </p>
              </div>
            </Col>

            <Col xs={12} sm={12} md={6} lg={3} className="mb-4">
              <div className="feature-card">
                <i className="bi bi-globe feature-icon"></i>
                <h3 className="feature-title">
                  A Large Selection of Exciting Games
                </h3>
                <p className="feature-description">
                  We offer a massive collection of thrilling and high-energy
                  games to entertain every gamer. Join our action-packed,
                  fast-paced games, delivering an exhilarating adrenaline rush
                  online. Battle for your survival in Zombie Apocalypse or
                  embark on an epic adventure in ancient times with the Prince
                  of Persia. Excitement never ends here.
                </p>
              </div>
            </Col>
            <Col xs={12} sm={12} md={6} lg={3} className="mb-4">
              <div className="feature-card">
                <i className="bi bi-eye feature-icon"></i>
                <h3 className="feature-title">
                  Exclusive Bonuses and Rewards for New Players{" "}
                </h3>
                <p className="feature-description">
                  Get amazing bonuses and rewards with the Orion Stars download.
                  We welcome new gamers with an exciting 200% bonus on the first
                  deposit. Jump into action today and start your winning
                  journey.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Description;
